module.exports = "<div role=\"alert\" aria-live=\"assertive\" id=\"game_alert\"></div>\n";